import React, { useEffect } from "react";

import Image from "next/image";
import { IHowToLearnDetailInput } from "../types";
import { useRouter } from "next/router";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import howToLearnApi from "../helpers/howToLearnApi";
import HowToLearnDetailHeader from "./DetailHeader";
import HowToLearnDetailHeaderSkeleton from "./skeleton/DetailHeaderSkeleton";
import HowToLearnDetailResult from "./DetailResult";
import RelatedLandings from "./RelatedLandings";
import Faqs from "./Faqs";

interface Props {
  productCollection?: IHowToLearnDetailInput;
}

const HowToLearnDetail: React.FC<Props> = ({
  productCollection: initialProductCollection,
}) => {
  const router = useRouter();
  const slug = typeof router.query.slug === "string" ? router.query.slug : "";

  const { data: fetchedProductCollection, error } = useRequestImmutable(
    slug ? howToLearnApi.singleHowToLearn(slug) : null,
    { shouldRetryOnError: false }
  );

  const productCollection =
    initialProductCollection ?? fetchedProductCollection;

  useEffect(() => {
    if (error?.error?.code === 404) router.replace("/404");
  }, [error, router]);
  const showFaq =
    productCollection?.data?.faqs && productCollection?.data?.faqs.length;
  return (
    <div className="relative   ">
      <div className=" px-4 hidden md:block md:px-6 lg:px-10 xl:px-0 xl:max-w-[1200px] mx-auto ">
        <div className="md:h-14  overflow-hidden opacity-80  h-12 w-full relative my-4">
          <Image
            src="https://faradars.org/wp-content/uploads/2026/07/14/howtolearnbg.svg"
            alt="howtolearnbg"
            fill
            loading="eager"
            fetchPriority="high"
            className="object-cover object-right"
          />
        </div>
      </div>

      {productCollection ? (
        <HowToLearnDetailHeader productCollection={productCollection} />
      ) : (
        <HowToLearnDetailHeaderSkeleton />
      )}
      <div className="h-1.5 w-full lg:hidden bg-fds-secondary  " />
      <HowToLearnDetailResult productCollection={productCollection} />
      {productCollection?.data.count_product ? <RelatedLandings /> : null}
      {showFaq ? <Faqs data={productCollection.data.faqs} /> : null}
    </div>
  );
};

export default HowToLearnDetail;
